export default "__VITE_ASSET__BZKKOand__"